export default "__VITE_ASSET__NdaSTW$F__"